import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	rename: {
		id: 'business-list.list-view.category-cell.edit-category-cell.custom-select-option.rename',
		defaultMessage: 'Rename',
		description: 'Label text for rename category',
	},
	delete: {
		id: 'business-list.list-view.category-cell.edit-category-cell.custom-select-option.delete',
		defaultMessage: 'Delete',
		description: 'Label text for delete category',
	},
	confirm: {
		id: 'business-list.list-view.category-cell.edit-category-cell.custom-select-option.confirm',
		defaultMessage: 'Confirm',
		description: 'Label text for confirm rename category',
	},
	cancel: {
		id: 'business-list.list-view.category-cell.edit-category-cell.custom-select-option.cancel',
		defaultMessage: 'Cancel',
		description: 'Label text for cancel rename category',
	},
});
